import { render, staticRenderFns } from "./SectionShow.vue?vue&type=template&id=440a7960&"
import script from "./SectionShow.vue?vue&type=script&lang=js&"
export * from "./SectionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports